var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wait"},[_c('div',{staticClass:"inline-block"},[_c('img',{staticClass:"wait-img",attrs:{"src":require("../../../static/img/waiting.png")}})]),_vm._v(" "),_c('div',{staticClass:"inline-block"},[_c('h6',[_vm._v("此功能暂未开放")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70f4a58a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/Message.vue
// module id = null
// module chunks = 